import {customElement, property} from "lit/decorators.js";
import {html, LitElement} from "lit";

@customElement('app-bible-header')
export class BibleHeader extends LitElement {
  @property({ type: Object }) element: Element;

  createRenderRoot = () => this

  render() {
    const revDesc = this.element.querySelector('revisionDesc')!;
    const work = this.element.querySelector('work')!;

    return html`
      <details>
        <summary>
          <h1>${work?.querySelector('identifier')?.innerHTML}</h1>
        </summary>
        <div>
          <pre>${work?.querySelector('description')?.innerHTML}</pre>
          <h2>Revision</h2>
          <div>Date: ${revDesc?.querySelector('date')?.textContent}</div>
          <div>Note: ${revDesc?.querySelector('p')?.textContent}</div>
  
          <h2>Work Info</h2>
          <table>
            <tr><td>Title</td><td>${work?.querySelector('title')?.textContent}</td></tr>
            <tr><td>Creators</td>
                <td>
                  ${[...work?.querySelectorAll('creator') || []]
      .map(c => c.textContent + (c.getAttribute('role') ? ` (${c.getAttribute('role')})` : ''))
      .join(', ')}
                </td></tr>
            <tr><td>Subject</td><td>${work?.querySelector('subject')?.textContent}</td></tr>
            <tr><td>Date</td><td>${work?.querySelector('date')?.textContent}</td></tr>
            <tr><td>Type</td><td>${work?.querySelector('type')?.textContent}</td></tr>
            <tr><td>Identifier</td><td>${work?.querySelector('identifier')?.textContent}</td></tr>
            <tr><td>Source</td><td>${work?.querySelector('source')?.textContent}</td></tr>
            <tr><td>Language</td><td>${work?.querySelector('language')?.textContent}</td></tr>
            <tr><td>Rights</td><td>${work?.querySelector('rights')?.textContent}</td></tr>
            <tr><td>RefSystem</td><td>${work?.querySelector('refSystem')?.textContent}</td></tr>
          </table>
        </div>
      </details>
    `;
  }
}
